import React from 'react';
import { Pill } from '@99designs/common/components/Pill';
import { DesignerLevel } from 'apps/find-designers/propTypes';
import { LEVEL_ENTRY, LEVEL_MID, LEVEL_TOP } from 'apps/find-designers/consts';

function levelName(level) {
    switch (level) {
        case LEVEL_ENTRY:
            return __('Entry Level');
        case LEVEL_MID:
            return __('Mid Level');
        case LEVEL_TOP:
            return __('Top Level');
        default:
            return null;
    }
}

export default function LevelPill({ level }) {
    return <Pill variations={[`${level}-level`]}>{levelName(level)}</Pill>;
}

LevelPill.propTypes = {
    level: DesignerLevel.isRequired,
};



// WEBPACK FOOTER //
// ./src/js/components/Designers/LevelPill.jsx